import { MetaDataLabel } from '@/styles/fonts'
import { InputHTMLAttributes } from 'react'
import styled from 'styled-components'

export type InputState = 'error' | 'success' | 'default'

export interface GrandstandInputProps extends InputHTMLAttributes<HTMLInputElement> {
  state?: InputState
  message?: string
  label?: string
}

const colorForState = (state: InputState) => {
  switch (state) {
    case 'error':
      return `var(--error)`
    case 'success':
      return `var(--success)`
    case 'default':
      return `var(--divider-canvas)`
  }
}

const borderForState = (state: InputState) => {
  switch (state) {
    case 'error':
      return `1px solid var(--error)`
    case 'success':
      return `1px solid var(--success)`
    case 'default':
      return `1px solid var(--divider-canvas)`
  }
}

const InputContainer = styled.div<GrandstandInputProps>`
  padding: 8px;
  border: ${(props) => borderForState(props.state ?? 'default')};
  border-radius: 4px;
  &:focus-within {
    border: 1px solid var(--button-alt);
  }
`

const Label = styled.span<{ showLabel: boolean }>`
  display: block;
  font-size: var(--metadata-xs-size);
  color: var(--on-background-alt);
  margin-bottom: 5px;
  background-color: rgba(0, 0, 0, 0);
`

export const Input = styled.input<GrandstandInputProps>`
  all: unset;
  display: block;
  font-size: var(--metadata-md-size);
  line-height: var(--metadata-line-height);
  font-weight: var(--metadata-font-weight);
  font-family: var(--metadata-font-fam);
  background-color: rgba(0, 0, 0, 0);
  color: var(--on-background);
  padding: 0;
  ::placeholder {
    color: var(--on-background-alt);
  }
  &[disabled],
  &:disabled {
    border: 1px solid var(--disabled);
    color: var(--on-background-alt);
  }
  width: 92%;
`

const Wrapper = styled.div<GrandstandInputProps>`
  color: ${(props) => colorForState(props.state ?? 'default')};
`

const Message = styled(MetaDataLabel)``

export const GrandstandInput = ({ state, message, label, ...inputProps }: GrandstandInputProps) => {
  label = label ?? inputProps?.placeholder ?? ''
  const showLabel = inputProps?.value !== ''
  return (
    <Wrapper state={state}>
      <InputContainer state={state}>
        <Label showLabel={showLabel}>{label}</Label>
        <Input {...inputProps}></Input>
      </InputContainer>
      {message && <Message fontSize="sm">{message}</Message>}
    </Wrapper>
  )
}
